module.exports = __webpack_public_path__ + "static/media/vk.b6d8104a.png";